// extracted by mini-css-extract-plugin
export default {"userterm":"UserTerm_userterm__g2S09","download_btn":"UserTerm_download_btn__kgOiB"};